'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import type React from 'react';
import { cn } from '@/app/_lib/utils';
export interface DialogProps extends Omit<Headless.DialogProps, 'className'> {
  className?: string;
}
export const Dialog = t0 => {
  const $ = _c(13);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("fixed inset-0 z-50");
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Headless.DialogBackdrop className="fixed inset-0 backdrop-blur-xs transition-opacity" aria-hidden="true" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className) {
    t3 = cn("mx-auto w-full max-w-md overflow-hidden rounded-2xl bg-backgroundPrimary p-6 text-left align-middle shadow-xl transition-all", "border border-borderPrimary", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props.children || $[8] !== t3) {
    t4 = <div className="relative">{t2}<div className="fixed inset-0 overflow-y-auto"><div className="mt-8 flex min-h-full items-start justify-center p-4 text-center"><Headless.DialogPanel className={t3}>{props.children}</Headless.DialogPanel></div></div></div>;
    $[7] = props.children;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props || $[11] !== t4) {
    t5 = <Headless.Dialog as="div" {...props} className={t1}>{t4}</Headless.Dialog>;
    $[10] = props;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};